import EntityEdit from "./EntityEdit";
import { withTranslation } from 'react-i18next';

export default withTranslation()(EntityEdit);
